import { Chip } from "@mui/material";
import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { useTheme } from "@mui/material/styles";
import { FIELD_PREFIX } from "../../../utils";

const DragItem = ({ token }) => {
  const theme = useTheme();
  const textColor = theme.palette.mode === "dark" ? "#fff" : "#000";
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `${FIELD_PREFIX}${token}`,
    data: { type: "field", name: token }
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0 : 1,
        cursor: "grab",
        maxWidth: "100%"
      }}
    >
      <Chip
        size="small"
        label={token}
        sx={{
          maxWidth: "100%",
          cursor: "grab",
          color: textColor,
          bgcolor: "transparent",
          borderColor: "transparent",
          "& .MuiChip-label": {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: textColor
          }
        }}
      />
    </div>
  );
};

export default DragItem;
